import React from 'react'
import {Link} from 'react-router-dom'

export const Sale = (props) => {

    return (
        <div className="Sale-block">
            <div className="text-center Sale-block__img">
                <Link to="/">
                    <img src={props.ImgUrl} alt=""/>
                </Link>
            </div>
            <div className="Sale-block__productInfoBlock">
                <p className="Sale-block__productName text-center">{props.ProductName}</p>
                <div>
                    <Link to="/" className="Sale-block__productInfo">{props.ProductInfo}</Link>
                </div>
                <div className="mt-4">
                    <span className="Sale-block__productNewPrice">{props.NewPrice}</span>
                    <span className="Sale-block__productOldPrice ml-1">{props.OldPrice}</span>
                </div>
                <button className="btn Sale-block__productAddCard">В корзину</button>
            </div>
        </div>
    )
}